import React from 'react'
import './NewsLettr.css'
const NewsLettr = () => {
  return (
    <div className='newslettr'>
      <h1>Get Exclusive Offers On Your Email</h1>
      <p>Subscribe to our newsletter and stay updated</p>
      <div>
        <input type="email" placeholder='Your Email id' />
        <button>Subscribe</button>
      </div>
    </div>
  )
}

export default NewsLettr
